<template>
  <div>
    <b-row>
      <b-col cols="12" sm="12" xl="4">
        <base-input label="Name" v-model="name" ref="name"></base-input>
      </b-col>

      <b-col cols="12" sm="6" xl="4">
        <label class="form-control-label">Value</label>
        <currency-input
          class="form-control"
          v-model="shareValue"
          :currency="currency"
          :value-as-integer="true"
        />
        <small class="text-muted">Per share</small>
      </b-col>

      <b-col cols="12" sm="6" xl="4">
        <base-input type="number" label="Total" v-model="nominalTotalShares">
          <small class="text-muted" slot="infoBlock">Nominal shares</small>
        </base-input>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="6">
        <b-btn @click="$emit('cancel')" variant="outline-secondary" block>
          <i class="fa fa-times mr-2"></i> Cancel
        </b-btn>
      </b-col>
      <b-col cols="12" md="6">
        <b-btn @click="create" variant="success" block>
          <span v-if="!creating">
            Create class
            <i class="fa fa-arrow-right ml-2"></i>
          </span>
          <span v-else>
            <i class="fa fa-spin fa-spinner mr-2"></i> Please wait&hellip;
          </span>
        </b-btn>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { get } from "dot-prop";

export default {
  name: "share-class-create-form",
  components: {},
  props: {
    companyId: {
      type: String,
      description: "Company ID",
      required: true
    },
    currency: {
      type: String,
      description: "ISO Currency Code",
      required: true
    }
  },
  data() {
    return {
      name: "Ordinary",
      shareValue: 100,
      nominalTotalShares: 2000,
      creating: false,
      errorMessage: null
    };
  },
  computed: {
    account: function() {
      return this.$store.state.account;
    }
  },
  methods: {
    setFocus() {
      this.$nextTick(() => {
        // focus on input NOTE: this doesn't work
        // this.$refs.name.focus();
      });
    },
    create() {
      this.creating = true;
      const requestBody = {
        name: this.name,
        shareValue: this.shareValue,
        nominalTotalShares: this.nominalTotalShares
      };

      this.axios
        .post(
          `/v1/accounts/${this.account.id}/companies/${this.companyId}/share-classes`,
          requestBody
        )
        .then(response => {
          this.creating = false;
          if (response.data) {
            const shareClass = response.data;
            this.$emit("share-class-created", shareClass);
          }

          this.$notify({
            message: "Share class created",
            timeout: 3000,
            icon: "fa fa-check",
            type: "success"
          });
        })
        .catch(error => {
          this.creating = false;
          this.errorMessage = "Failed to create share class";
          if (get(error, "response.data.message")) {
            this.errorMessage = error.response.data.message;
          }
        });
    }
  }
};
</script>
